import { render, staticRenderFns } from "./backup-restore.vue?vue&type=template&id=4bc012be&scoped=true&"
import script from "./backup-restore.vue?vue&type=script&lang=js&"
export * from "./backup-restore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc012be",
  null
  
)

/* custom blocks */
import block0 from "./backup-restore.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports